module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "categoryOverview"
    }
  }, [_c('div', {
    staticClass: "card card-default mb-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h2', {
    staticClass: "mt-0 strong"
  }, [_vm._v(_vm._s(_vm.labels.MY_APPLICATION_TEXT))]), _vm._v(" "), _c('div', {
    staticClass: "product-categories stretch-boxes"
  }, [_c('div', {
    staticClass: "flex-row"
  }, [(_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM || _vm.userHasDigi()) ? _c('div', {
    staticClass: "flex-col"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-image": "url(./././static/img/mmk_karton_bg.png)",
      "background-position": "top left",
      "background-size": "contain"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body small"
  }, [_vm._v("\n                        MM Digital platform\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "margin-bottom4"
  }, [_vm._v("Links:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline"
  }, _vm._l((_vm.dashBoardDigiLinks), function(link) {
    return (_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM || _vm.userInGroup(link.Group)) ? _c('li', [_c('a', {
      staticClass: "underlined",
      attrs: {
        "href": link.Url
      }
    }, [_c('span', [_vm._v(_vm._s(link.Title))])])]) : _vm._e()
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM || _vm.userHasMMPDigi()) ? _c('div', {
    staticClass: "flex-col"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-image": "url(./././static/img/mmk_karton_bg.png)",
      "background-position": "top left",
      "background-size": "contain"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body small"
  }, [_vm._v("\n                        MMP Digital platform\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "margin-bottom4"
  }, [_vm._v("Links:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline"
  }, _vm._l((_vm.dashBoardMMPLinks), function(link) {
    return (_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM || _vm.userInGroup(link.Group)) ? _c('li', [_c('a', {
      staticClass: "underlined",
      attrs: {
        "href": link.Url
      }
    }, [_c('span', [_vm._v(_vm._s(link.Title))])])]) : _vm._e()
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM || _vm.userHasSharePoint()) ? _c('div', {
    staticClass: "flex-col"
  }, [_vm._m(2)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header small"
  }, [_c('div', {
    staticClass: "cat-header"
  }, [_c('div', [_c('small', {
    staticClass: "strong text-uppercase"
  }, [_vm._v("MM Digital platform")])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-uppercase"
  }, [_c('div', {
    staticClass: "text-uppercase"
  }, [_c('span', {
    staticClass: "cat-wlc"
  }, [_vm._v("MM Digital platform")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header small"
  }, [_c('div', {
    staticClass: "cat-header"
  }, [_c('div', [_c('small', {
    staticClass: "strong text-uppercase"
  }, [_vm._v("MMP Digital platform")])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-uppercase"
  }, [_c('div', {
    staticClass: "text-uppercase"
  }, [_c('span', {
    staticClass: "cat-wlc"
  }, [_vm._v("MMP Digital platform")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header small"
  }, [_c('div', {
    staticClass: "cat-header"
  }, [_c('div', [_c('small', {
    staticClass: "strong text-uppercase"
  }, [_vm._v("MM SharePoint Extranet")])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-uppercase"
  }, [_c('div', {
    staticClass: "text-uppercase"
  }, [_c('span', {
    staticClass: "cat-wlc"
  }, [_vm._v("MM SharePoint Extranet")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body small"
  }, [_vm._v("\n                    MM SharePoint Extranet\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "margin-bottom4"
  }, [_vm._v("Links:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline"
  }, [_c('li', [_c('a', {
    staticClass: "underlined",
    attrs: {
      "href": "https://extranet.mayr-melnhof.com"
    }
  }, [_c('span', [_vm._v("MM SharePoint Extranet")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fa0b030","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardHome/DashboardHome.vue
// module id = 186
// module chunks = 1